/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import mbpLogger from 'mbp-logger';
import { compose } from 'recompose';
import { Query } from 'react-apollo';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { object, string, shape } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

import ConnectedCart from './Cart';
import Favorites from './Favorites';
import ConnectedSignIn from './SignIn/SignIn';

import { GRAPHQL_ENV } from '../../../gql';
import findHeaderAndCountries from '../../../gql/queries/findHeaderAndCountries';
import { setLocale } from '../../../../state/ducks/Member/ducks/Auth/helper/helper';
import { getFeatureFlags } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';

const TARGET_DESKTOP = 'desktop';

const styles = (theme) => ({
    CheckoutHeaderOptions: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 5,
        '& .MuiContainer-maxWidthLg': {
            margin: 0,
            width: 'max-content',
            [theme.breakpoints.down('md')]: {
                display: 'none',
            },
        },

        '& >a': {
            [theme.breakpoints.down('md')]: {
                padding: '15px 5px 0',
            },
        },
    },
});

const CheckoutHeaderPLA = (props) => {
    const { brand, featureFlags, classes } = props;
    const HEADER_QUERY = findHeaderAndCountries(brand, setLocale(), TARGET_DESKTOP, '');

    return (
        <Query query={HEADER_QUERY}>
            {({ loading, error, data }) => {
                if (loading) {
                    return null; // skeleton component
                }

                if (error) {
                    mbpLogger.logError({
                        query: HEADER_QUERY,
                        component: 'CheckoutHeaderPLA.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }

                if (!data) {
                    mbpLogger.logWarning({
                        query: HEADER_QUERY,
                        component: 'CheckoutHeaderPLA.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }

                if (!data?.findHeader?.content?.entries?.length || !data.findHeader.content.entries[0]?.header_blocks?.length) {
                    mbpLogger.logError({
                        message: 'No header blocks returned from API in CheckoutHeaderPLA',
                        brand,
                    });
                    return null;
                }

                const headerBlocks = data?.findHeader?.content?.entries?.[0]?.header_blocks || [];

                return (
                    <div className={classes.CheckoutHeaderOptions}>
                        {headerBlocks[0]?.menu?.menu_ref[0]?.menu_blocks[1]?.menu_links?.menu_link.map(
                            (obj) => {
                                const title = obj && obj.link && obj.link.title ? obj.link.title : null;
                                const icon = obj.icon;

                                switch (title) {
                                    case 'Favorite':
                                        return <Favorites image={icon} />;

                                    case 'Sign In':
                                        return (featureFlags['is-signin-enabled']) ? <ConnectedSignIn image={icon} /> : null;

                                    case 'Shopping Cart':
                                        return <ConnectedCart image={obj.icon} brand={brand} />;

                                    default:
                                        mbpLogger.logError({
                                            message: `Unknown menu-block-link ${title} or unexpected structure in DesktopHeaderBlock`,
                                            brand,
                                            obj,
                                        });
                                        return null;
                                }
                            },
                        )}
                    </div>
                );
            }}
        </Query>
    );
};

CheckoutHeaderPLA.propTypes = {
    classes: object.isRequired,
    brand: shape({
        domain: string.isRequired,
    }).isRequired,
    featureFlags: shape({
        'which-checkout-variation': string,
    }).isRequired,
};

const mapStateToProps = (state) => ({
    featureFlags: getFeatureFlags(state),
});

const enhance = compose(
    connect(mapStateToProps),
    withRouter,
    withStyles(styles),
);

export default enhance(CheckoutHeaderPLA);
